import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  background: #ffffff;
  border: none;
  box-sizing: border-box;
  padding: 24px;
`;
const TitleModal = styled.span`
  font-weight: bold;
  font-size: 18px;
  letter-spacing: 0.25px;
  color: #2b2b2b;
  margin-bottom: 8px;
`;
const TextFieldDescription = styled.span`
  font-size: 16px;
  color: #2b2b2b;
  letter-spacing: 0.25px;
  text-align: center;
  margin-bottom: 32px;
`;
const BoxButton = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const ButtonCancel = styled.button`
  width: 100%;
  height: 40px;
  font-weight: 600;
  font-size: 14px;
  color: #06a3b4;
  letter-spacing: 0.25px;
  border-radius: 24px;
  background-color: transparent;
  border: none;
  border: 2px solid #39a1ac;
  margin-bottom: 8px;
`;
const ButtonConfirm = styled.button`
  width: 100%;
  height: 40px;
  background: #06a3b4;
  border-radius: 24px;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.25px;
  border: none;
`;
const ImageRecordComplete = styled.img`
  margin-bottom: 32px;
`;

const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    zIndex: 20,
  },

  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '327px',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '0',
  },
};

export default function ModalCompletedRecord({
  isOpen,
  closeModal,
  handleClick,
  handleClosePopup,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={customStyles}
      ariaHideApp={false}
    >
      <Container>
        <ImageRecordComplete src="/images/icon-record.svg" />
        <TitleModal>บันทึกข้อมูลเสร็จสิ้น</TitleModal>
        <TextFieldDescription>
          ข้อมูลบันทึกติดตามอาการของสัปดาห์นี้ ถูกบันทึกเรียบร้อยแล้ว
        </TextFieldDescription>
        <BoxButton>
          <ButtonCancel onClick={() => handleClick()}>
            สรุปบันทึกอาการของฉัน
          </ButtonCancel>
          <ButtonConfirm onClick={() => handleClosePopup()}>
            กลับสู่หน้าแชท
          </ButtonConfirm>
        </BoxButton>
      </Container>
    </Modal>
  );
}
